import React, { useEffect, useMemo, useRef, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import Layout from "../../layout";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ErrorMessage } from "@hookform/error-message";
import {
  Table,
  Button,
  Modal,
  Form,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { InputField } from "../../components/InputField/InputField";
import services from "../../API/services";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import { Controller } from "react-hook-form";
import moment from "moment";
import Moment from "react-moment";
import {
  createInventoryOptions,
  createOptions,
  showPrice,
} from "../../utils/utils";
import Select from "react-select";
import { useDownloadExcel } from "react-export-table-to-excel";
import ReactGA from "react-ga4";
import {
  addInAndOutStockService,
  getSupplierItem,
} from "API/services/newServices";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const validation1 = Yup.object().shape({
  price: Yup.string().required("Please Enter Price*"),
  totalAmount: Yup.string().required("Please Enter Total Amount*"),
  quantity: Yup.string().required("Please Enter Quntity*"),
  unit: Yup.string().required("Please Enter Unit*"),
  supplierId: Yup.object().required("Please select Supplier *"),
  item: Yup.object().required("Please select Item*"),
  // expDate: Yup.string().required("Please select expiry date*"),
  selectCategory: Yup.string().required("Please select Category*"),
  stockStatus: Yup.string().required("Please select Stock type*"),
});
const validation2 = Yup.object().shape({
  price: Yup.string().required("Please Enter Price*"),
  quantity: Yup.string().required("Please Enter Quntity*"),
  supplierId: Yup.object().required("Please select Supplier *"),
  item: Yup.object().required("Please select Item*"),
  stockStatus: Yup.string().required("Please select Stock type*"),
  selectReason: Yup.string().required("Please select reason to out*"),
  remark: Yup.string().required("Enter Remark*"),
});

const STOCK_STATUS = ["IN", "OUT"];

const instockValidation = { resolver: yupResolver(validation1) };
const outstockValidation = { resolver: yupResolver(validation2) };

const InventoryReport = () => {
  const [tableData, setTableData] = useState([]);
  const [stockTableData, setStockTableData] = useState([]);
  const [stockTableDataFilter, setStockTableDataFilter] = useState([]);
  const [suppilerData, setSuppilerData] = useState([]);

  const [validation, setValidation] = useState(instockValidation);

  const { userDetail } = useSelector(authenticationSeletor);

  const getEmplyoee = async () => {
    try {
      const data = await services.property.getInventoryEmplyoee();
      const onlyProperty = data?.data?.result?.filter((item) => {
        return item?.propertyId === userDetail?.propertyId;
      });
      const dataSet = createOptions(onlyProperty, "firstName", "id");
      setSuppilerData(dataSet);
    } catch (error) {}
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getDataHandler(userDetail?.propertyId);
    getDataHandlers(userDetail?.propertyId);
    getDataHandlerSupplier(userDetail?.propertyId);
  }, []);

  const { AlertIcon } = Imagesdata || {};
  const [show, setShow] = useState(false);

  const [editMode, setEditMode] = useState(false);
  const [itemsData, setItemsData] = useState([]);
  const [itemDataMaster, setItemDataMaster] = useState([]);
  const [remarkShow, setRemarkShow] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm({ ...validation, mode: "onSubmit" });

  const getDataHandler = async (id) => {
    try {
      const res = await services.globalService.getInventoryCategoryService(id);
      if (res.status === 200) {
        setTableData(res.data.data);
      }
    } catch (error) {}
  };

  const onSubmit = async (payload) => {
    const stockSt = +payload.stockStatus;

    let realPayload = {
      propertyId: userDetail?.propertyId,
      categoryId: payload.selectCategory,
      employeeId: 0,
      suplierId: payload?.supplierId?.value,
      itemName: payload.item?.label,
      itemId: payload.item?.value,
      // avaiableQuantity: payload.avaiableQuantity,
      remark: payload.remark ?? "",
      status: 0,
      reasonToOutStock: payload.selectReason,
      unit: payload.unit,
      quantity: +payload.quantity,
      price: +payload.price,
      totalAmount: payload.totalAmount,
      mfdDate: moment().format("YYYY-MM-DD"),
      expDate: moment(payload.expDate).format("YYYY-MM-DD"),
      createdBy: userDetail.id,
      inStock: true,
    };

    if (stockSt == 2) {
      realPayload = {
        propertyId: userDetail?.propertyId,
        employeeId: payload?.supplierId?.value,
        itemId: payload.item?.value,
        quantity: payload.quantity,
        remark: payload.remark ?? "",
        status: 0,
        reasonToOutStock: payload.selectReason,
        updatedBy: userDetail.id,
      };
    }

    const res = await addInAndOutStockService(realPayload);
    if (res) {
      reset();
      // setEditMode(false);
      getDataHandlers(userDetail?.propertyId);
      setShow(false);
      // setSelectedData({});
    }
  };

  const { quantity, price, selectCategory, stockStatus, supplierId } = watch();
  useEffect(() => {
    if (show) {
      setValue("selectCategory", "");
      setValue("item", "");
      setValue("supplierId", "");
      if (+stockStatus == 2) {
        getEmplyoee();
        setRemarkShow(true);
        setValidation(outstockValidation);
      } else {
        getDataHandlerSupplier(userDetail.propertyId);
        setRemarkShow(false);
        setValidation(instockValidation);
      }
      setItemsData([]);
    }
  }, [stockStatus]);
  useMemo(() => {
    setValue("totalAmount", quantity * price);
  }, [quantity, price]);

  const getDataHandlers = async (id) => {
    try {
      const res = await services.globalService.getInStockService(id);
      if (res.status === 200) {
        setStockTableData(res.data.data);
      }
    } catch (error) {}
  };

  const getDataHandlerSupplier = async (id) => {
    try {
      const res = await services.globalService.getSupplierByPropertyIdService(
        id
      );
      if (res.status === 200) {
        const dataSet = createOptions(res.data.data, "name", "id");
        setSuppilerData(dataSet);
      }
    } catch (error) {}
  };

  const getDataHandlerItems = async (id) => {
    const res = await getSupplierItem(id);
    if (res) {
      setItemDataMaster(res);
      setItemsData(
        createInventoryOptions(res, "InventoryItem", "itemId", "itemName")
      );
    }
  };
  const getItemsByCategory = async (id) => {
    const res =
      await services.globalService.getInventoryItemByPropertyIdService(
        userDetail.propertyId
      );
    if (res.status === 200) {
      const onlyInstocks = res.data.data.filter((i) =>
        stockTableData.some((item) => item.itemId == i.id)
      );
      const filtered = onlyInstocks.filter((i) => i.categoryId == id);
      setItemDataMaster(onlyInstocks);
      setItemsData(createOptions(filtered, "itemName", "id"));
    }
  };

  useEffect(() => {
    if (supplierId?.value && show && !remarkShow) {
      getDataHandlerItems(supplierId?.value);
    }
  }, [supplierId?.value]);
  useEffect(() => {
    if (selectCategory && show) {
      if (+stockStatus == 1) {
        const filter = itemDataMaster.filter(
          (i) => i.categoryId == selectCategory
        );
        setItemsData(
          createInventoryOptions(filter, "InventoryItem", "itemId", "itemName")
        );
      } else {
        getItemsByCategory(selectCategory);
      }
    }
  }, [selectCategory]);

  const itemChangeHandler = (data) => {
    if (remarkShow) {
      let getSelected = itemDataMaster.find(
        (dataSet) => dataSet.id == data.value
      );
      setValue("price", getSelected.price);
    } else {
      let getSelected = itemDataMaster.find(
        (dataSet) => dataSet.itemId == data.value
      );
      setValue("unit", getSelected.InventoryItem?.unit);
      setValue("price", getSelected.InventoryItem?.price);
    }
  };

  const tableRef = useRef();
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "SearchResults",
    sheet: "SearchResults",
  });
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "inventory" });
    setStockTableDataFilter(stockTableData);
  }, [stockTableData]);
  const [filterDate, setFilterDate] = useState(new Date());

  const dateFilter = () => {
    const resultsData = stockTableData.filter((order) => {
      return (
        new Date(order?.createdAt).toJSON().slice(0, 10) >=
        new Date(filterDate).toJSON().slice(0, 10)
      );
    });
    setStockTableDataFilter(resultsData);
  };
  useEffect(() => {
    dateFilter();
  }, [filterDate]);

  const searchfilter = (text, fromHeads = false, innerKey = null) => {
    const resultsData = stockTableData.filter((order) => {
      if (text === "") return stockTableData;
      // 0 in
      // 1 out
      let params = innerKey ? order[fromHeads]?.[innerKey] : order[fromHeads];
      if (fromHeads === "stockType") {
        params = STOCK_STATUS[order.stockType];
      }
      if (!fromHeads) {
        params =
          order?.itemId +
          order?.itemName +
          order?.categoryId +
          order.unit +
          order.price +
          order.totalAmount +
          order.quantity +
          order?.Suplier?.name +
          order?.InventoryCategory?.name;
      }
      return params?.toString().toLowerCase()?.includes(text?.toLowerCase());
    });

    setStockTableDataFilter(resultsData);
  };

  const setChangeHeadsVal = (e) => {
    const name = e.target.name;
    let innerKey = null;
    if (name === "Suplier" || name === "InventoryCategory") {
      innerKey = "name";
    }

    searchfilter(e.target.value, name, innerKey);
  };

  return (
    <Layout
      title="Inventory Report"
      // openHandler={() => setShow(true)}
      extraBtnHandler={onDownload}
      extraButton="Export Table"
      searchfilter={searchfilter}
      setFilterDate={setFilterDate}
      filterDate={filterDate}
    >
      <div className="scrollTable">
        <Table striped bordered hover className="common-table" ref={tableRef}>
          <thead>
            <tr>
              <th>Supplier Name/Id</th>
              <th>Category</th>
              <th>Item</th>
              <th>Unit</th>
              <th>Quantity</th>
              <th>Availabe Quantity</th>
              <th>Price</th>
              <th>Total amount</th>
              <th>Exp.Date</th>
              <th>Date</th>
              <th>Status</th>
              <th>Remark</th>
              <th>Reason for out stock</th>
            </tr>
          </thead>
          <tbody>
            {stockTableDataFilter.map((data, key) => (
              <tr key={key}>
                <td>
                  {suppilerData.find((i) => i.value == data?.suplierId)?.label}{" "}
                  #{data?.suplierId}
                </td>
                <td>{data.InventoryCategory?.name}</td>
                <td>{data.itemName}</td>
                <td>{data.unit}</td>
                <td>{data.quantity ?? "N/A"}</td>
                <td>{data.avaiableQuantity ?? "N/A"}</td>
                <td>{showPrice(data.price)}</td>
                <td>{showPrice(data.totalAmount)}</td>
                {/* <td>
                    {data.mfdDate && (
                      <Moment format="DD/MM/YYYY">{data.mfdDate}</Moment>
                    )}
                  </td> */}
                <td>
                  {data.expDate && (
                    <Moment format="DD MMM, YYYY">{data.expDate}</Moment>
                  )}
                </td>
                <td>
                  {data.createdAt && (
                    <Moment format="DD MMM, YYYY">{data.createdAt}</Moment>
                  )}
                </td>
                <td
                  className={`inStock fw-bold ${
                    !data.stockType ? "text-success" : "text-danger"
                  }`}
                >
                  {STOCK_STATUS[data.stockType]}
                </td>
                <td>{data.remarks ?? "N/A"}</td>
                <td>{data.reasonToOutStock ?? "N/A"}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Layout>
  );
};

export default InventoryReport;
